import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import { TableVariant } from '../../constants.js';
import { TableVariantContext } from './TableVariantContext.js';

const bem = Bem.create("vai-table__body");
class TableBody extends React.PureComponent {
  render() {
    const { htmlId, dataTa, component, children, className, ...rest } = this.props;
    const Component = component;
    const id = Id.create(htmlId, ["simple table body"]);
    const classNames = addClass(bem.block(), className);
    return /* @__PURE__ */ React.createElement(TableVariantContext.Provider, {
      value: { variant: TableVariant.Body }
    }, /* @__PURE__ */ React.createElement(Component, {
      id: id.toString(),
      className: classNames,
      "data-ta": dataTa,
      ...rest
    }, children));
  }
}
TableBody.defaultProps = {
  dataTa: "vai-table-body",
  component: "tbody"
};

export { TableBody, TableBody as default };
